<template>
  <div class="conmain">
    <div v-if="liad_show">
      <load></load>
    </div>
    <div>
      <el-select v-model="companyee_choiced_excel"  multiple filterable placeholder="请选择" style="float: left; width:10% ; margin-right: 10px;">
        <el-option
          v-for="item in companyee_all"
          :key="item.num"
          :label="item.name"
          :value="item.num">
        </el-option>
      </el-select>
      <el-date-picker
        v-model="time"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions">
      </el-date-picker>
      <el-button type="primary" @click="department_c()" style="margin-left: 10px;margin-right: 10px;">按照部门选择</el-button>
      <el-button type="primary" @click="companyee_load_excel()" style="margin-left: 10px;margin-right: 10px;">整体导出</el-button>
       <el-button type="primary" @click="companyee_load_pdf('')">批量导出</el-button>
    </div>

    <el-table stripe :data="companyee_list.list" :row-style="{height:'70px'}" style="width: 100%; margin-top: 20px;" :row-key="companyee_choiced_click" @selection-change="companyee_choiced_change">
      <el-table-column type="selection">
      </el-table-column>
      <el-table-column label="编号" prop="num" width="" sortable>
      </el-table-column>
      <el-table-column label="姓名" prop="name" width="" sortable>
      </el-table-column>
      <el-table-column label="角色" width="" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.type=='2'">企业管理员</span>
          <span v-else-if="scope.row.type=='1'">部门管理员</span>
          <span v-else>普通员工</span>
        </template>
      </el-table-column>
      <el-table-column label="所属部门" prop="section" width="" sortable>
      </el-table-column>
      <el-table-column label="状态" width="" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.status==1">启用中</span>
          <span v-if="scope.row.status==2">已禁用</span>
          <span v-if="scope.row.status==3">已离职</span>
        </template>
      </el-table-column>
      <el-table-column align="right" width="150">
        <template slot="header" slot-scope="scope">
          <el-input v-model="search" size="mini" @keyup.enter.native="search_click()" placeholder="输入关键字搜索" />
        </template>
        <template slot-scope="scope">
          <el-button size="mini" @click="companyee_watch(scope.row.num)">查看</el-button>
          <el-button size="mini" type="primary" @click="companyee_load_pdf(scope.row.num)">导出</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="companyee_list.current_page" :page-sizes="[10, 20, 30, 40]" :page-size="companyee_list.per_page"
        layout="total, sizes, prev, pager, next, jumper" :total="companyee_list.total">
      </el-pagination>
    </div>
    <el-dialog :title="nav_status.title" :visible.sync="nav_status.companyee_watch_dialog" width="80%">
      <el-row :style="{height:height.all_height}" class="over_height">
        <div v-html="companyee_watch_info"></div>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="nav_status.companyee_watch_dialog=false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="组织架构" :visible.sync="department_info.show">
      <div class="ercitankuang_left">
         <p style="margin-top: 10px; margin-bottom: 20px;"><span style=" margin-left:10px;">请选择员工</span>
         <span style="position:absolute;  right: 5%;">
        <el-button   type="danger" icon="el-icon-delete" circle @click="removeper()"></el-button>
        <el-button type="success"  icon="el-icon-check" circle  @click="per_click"></el-button>
        </span></p>
       <el-input  v-model="per_value" placeholder="请输入内容"></el-input> <br />
        <el-tree
             show-checkbox
             :data="info.per_list"
             ref="treeper"
             node-key="num"
             :filter-node-method="filterNode"
             :default-checked-keys="setup.mr_xz_key"
            :props="setup.defaultProps">
        </el-tree>
      </div>
      <div class="ercitankuang_right">
        您选择的员工是：
       <p v-for="(item,key) in upload.xzper_list">{{item.name}}</p >
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="department_ok">确定</el-button>
        <el-button @click="department_info.show=false">关闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import load from '../../../../components/load.vue';
  export default {
    watch: {
         per_value(val) {
           // 根据关键词过滤
           this.$refs.treeper.filter(val);
         },
       },
    data() {
      return {
        height:{
          all_height:'',
          tree_height:'',
          yuangong_height:''
        },
        per_value:'',//选择人员
        upload:{
         xzper_list:[],//选择人员
        },
        setup:{
          morenkey:[],//默认展开的树
          defaultProps: {
            children: 'children',
            label: 'name',
          },
        },
        info:{
          per_list:[],
        },
        department_info:{
          show:false,
        },
        liad_show:false,
        nav_status:{
          companyee_watch_dialog:false,
          title:''
        },
        companyee_all:{},
        companyee_choiced:[],
        companyee_choiced_excel:[],
        companyee_list:{
          current_page: 1, // 当前页码
          total: 0, // 总条数
          per_page: 10,
        },
        companyee_watch_info:{
          content:{subject:{num:'0'}}
        },
        time:null,
        search: '',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    components: {
      load:load,
      },
    mounted() {
      this.height.all_height=window.innerHeight *0.6  + 'px'
      // this.height.yuangong_height=window.innerHeight *0.6  - 80 + 'px'
      this.height.tree_height=window.innerHeight *0.6 - 120 + 'px'
      this.get_companyee()
      this.get_companyee_all()
      this.get_department()
    },
    methods: {
      department_ok(){
        let _this=this
        _this.companyee_choiced_excel=[]
        for(let i=0;i<_this.upload.xzper_list.length;i++){
          _this.companyee_choiced_excel.push(_this.upload.xzper_list[i].num)
        }
      _this.department_info.show=false
        // _this.upload.xzper_list
      },
      unique(newarr) {
       const res = new Map();
       return newarr.filter((newarr) => !res.has(newarr.num) && res.set(newarr.num, 1));
      },
      filterNode(value, data) {
        if (!value) return true;
         return data.name.indexOf(value) !== -1;
           },
      get_department(){
        let _this = this;
        _this.axios.get("/v2/c_train/get_train_companyee_list").then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.info.per_list=res.data.data
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },
      removeper(){
        let _this=this;
        _this.upload.xzper_list=[];
         _this.$nextTick(function () {
                //Dom更新完毕
                this.$refs.treeper.setCheckedKeys([]);
              });
      },
      per_click() {
              let a=this.$refs.treeper.getCheckedNodes();
              this.upload.xzper_list=[];
              let j=0;
              for(let i=0;i<a.length;i++){
                if(a[i].hasOwnProperty('s_id')){
                  this.$set(this.upload.xzper_list,j,a[i])
                  j++;
                }
              }
              let newarr= this.unique(this.upload.xzper_list);
              this.upload.xzper_list=newarr
            },
      department_c(){
        let _this=this
        _this.department_info.show=true
      },
      search_click(){
        this.get_companyee()
      },
      companyee_choiced_click(companyee){},

      companyee_choiced_change(companyee){
        let _this=this
        _this.companyee_choiced=[]
        for(var i=0;i<companyee.length;i++){
          _this.companyee_choiced.push(companyee[i].num)
        }
      },

      companyee_load_pdf(num){
        let _this=this
        _this.liad_show=true
        if(_this.time==null){
          _this.time=['','']
        }
        if(num!=''){
          _this.companyee_choiced=[]
          _this.companyee_choiced.push(num)
        }else{
          _this.companyee_choiced=_this.companyee_choiced_excel
        }
        if(_this.companyee_choiced.length>0){
          
          var href='/v2/c_census/train_down_pdf?key='+localStorage.authorization+'&num='+_this.companyee_choiced.toString()+'&type=companyee&time='+_this.time[0]+'_'+_this.time[1]
          window.open(href,'_self')
          
        }else{
          _this.$message.error('请选择员工')
        }
        _this.liad_show=false
      },

      companyee_watch(num){
        let _this=this
        _this.liad_show=true
        _this.axios.get('/v2/c_census/get_companyee_train_info',{params:{'num':num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.liad_show=false
              _this.companyee_watch_info=res.data.data.html
              _this.nav_status.title=res.data.data.name
              _this.nav_status.companyee_watch_dialog=true
            }else{
              _this.$message.error(res.data.msg)
              _this.liad_show=false
            }
          }else{
            _this.$message.error('服务器内部错误')
            _this.liad_show=false
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
          _this.liad_show=false
        })
      },

      get_companyee(){
        let _this=this
        _this.axios.get("/v2/c_companyee/get_list",{params:{'page':_this.companyee_list.current_page,'limit':_this.companyee_list.per_page,'keyword':_this.search,'type':'section'}}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
                _this.companyee_list=res.data.data;
                _this.companyee_list.per_page=parseInt(_this.companyee_list.per_page)
            } else {
              _this.$message.error("服务器内部错误");
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      get_companyee_all(){
        let _this=this
        _this.axios.get("/v2/c_companyee/get_list",{params:{'page':1,'limit':99999,'status':'1'}}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
                _this.companyee_all=res.data.data.list;
            } else {
              _this.$message.error("服务器内部错误");
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      companyee_load_excel(){
        let _this=this
        _this.liad_show=true
        if(_this.time==null){
          _this.time=['','']
        }
        var data={'time':_this.time,'companyee':_this.companyee_choiced_excel}
        _this.axios.post('/v2/c_census/companyee_down_excel',{data:data},{responseType:'blob'}).then(function(res) {
          if(res.status=='200'){
            const blob = new Blob([res.data],{type: 'aplication/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'})
            const elink = document.createElement('a')
            elink.download = '员工任务详情.xlsx';
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
            _this.liad_show=false
          }else{
            _this.$message.error('服务器内部错误')
            _this.liad_show=false
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
          _this.liad_show=false
        });
      },

      handleSizeChange(val) {
        this.companyee_list.current_page = 1;
        this.companyee_list.per_page = val
        this.get_companyee()
      },

      handleCurrentChange(val) {
        let _this=this
        _this.companyee_list.current_page = val
        _this.get_companyee()
      }
    },
  }
</script>

<style scoped>
  .ercitankuang_left{
     border:1px solid 	#9D9D9D;
     height:400px;
     flex: 1;
     overflow:scroll;
     position:relative;
    }
   .ercitankuang_right{
     border:1px solid 	#9D9D9D;
     height:400px;
     flex: 1;
     overflow:scroll;
   }
    .ercitankuang_content{
         flex: 0.1;
       text-align:center;
       height: 400px;
     }
  .conmain {
    width: 100%;
    height: 100%;
  }

  .block {
    text-align: center;
    margin-top: 20px;
  }
  .over_height{
    overflow:auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/census/train/train_companyee.vue